import {useLayoutEffect} from 'react';
import {useLocation, useNavigationType} from 'react-router';
import {preferredScrollBehavior, scrollToElement} from '../../utils/scrollToElement';

const ScrollToTop = () => {
    const {pathname, hash, key} = useLocation();
    const navigationType = useNavigationType();

    useLayoutEffect(() => {
        if (!hash) {
            const rootStyle = document.documentElement.style;
            const previousBehavior = rootStyle.scrollBehavior;
            rootStyle.scrollBehavior = 'auto';
            window.scrollTo({top: 0, behavior: 'auto'});
            rootStyle.scrollBehavior = previousBehavior;
            return;
        }

        let elementId: string;
        try {
            elementId = decodeURIComponent(hash.slice(1));
        } catch {
            return;
        }
        const behavior = navigationType === 'POP' ? 'auto' : preferredScrollBehavior();
        if (scrollToElement(elementId, undefined, behavior)) return;

        // A route loaded on demand may not have rendered its anchor yet.
        const observer = new MutationObserver(() => {
            if (scrollToElement(elementId, undefined, behavior)) observer.disconnect();
        });
        observer.observe(document.getElementById('root') ?? document.body, {childList: true, subtree: true});
        return () => observer.disconnect();
    }, [pathname, hash, key, navigationType]);

    return null;
}

export default ScrollToTop;
